import { ObservationDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";
import { LabTabViews } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModelT } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEventWithRequest } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { ILoadGraphData } from "@/Labs/Stores/Actions/LabsAction";
import { LabsStore } from "@/Labs/Stores/LabsStore";

class LabsGraphResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);
        this.RegisterOperation(ServerOperations.Server.ARLMYLE_GetObservations, this.LoadGraphObservations);
    }

    private LoadGraphObservations(response: ServerEventWithRequest<ILoadGraphData>, store: LabsStore): void {
        let graphsData: ObservationDTO[][] = response.Data["ObservationDataGraphs"];
        if (!graphsData || graphsData.length == 0)
            return;

        graphsData = graphsData.filter(x => x.length > 0 && x.firstOrDefault() != null);
        graphsData = graphsData.sortByProperty(x => x.firstOrDefault().Text);

        let graphsDataAsDictionary: { [observationType: string]: ObservationDTO[] } = {};
        graphsData.forEach(graphData => {
            // Fix for any lab ids that contains colons. This is used in the LoadGraph() in PatientLabGraphComponent and fixes the weird JQuery that does not accept ':' as a valid caracter in an Id.
            let cleanIdentifier = labsStore.GetCleanId(graphData.firstOrDefault().StandardCode);
            graphsDataAsDictionary[cleanIdentifier] = graphData;
        });
        store.LabGraphModel = store.LabGraphModel.set("Observations", graphsDataAsDictionary);

        let graphsCheckboxes: CheckboxUIModelT<ObservationDTO>[] = [];
        graphsData.forEach(graphData => {
            let checked = response.requestDto.checkedIdentifiers
                .some(id => graphData.some(entry => entry.Identifier == id));

            let firstObx = graphData.firstOrDefault();
            let cb = new CheckboxUIModelT<ObservationDTO>();
            cb.Checked = checked;
            cb.Id = labsStore.GetCleanId(firstObx.StandardCode);
            cb.Model = firstObx;
            cb.Target = CheckboxTarget.Myle_Labs_Graphs;
            cb.Name = firstObx.Text;
            cb.Title = `${firstObx.Text} (${firstObx.StandardCode})`;

            graphsCheckboxes.push(cb);
        });

        store.LabGraphModel = store.LabGraphModel.set("ObservationTypesCheckBoxes", graphsCheckboxes.toImmutable());
        store.Model = store.Model.set("CurrentView", LabTabViews.Graph);
    }
}

export { LabsGraphResponseHandler };
